import IService from '../IService';

export default IService.extend({
  _omitUrlProtocol(url) {
    return url.replace(/(^\/\/|^http:\/\/|^https:\/\/)/i, '');
  },

  post(options) {
    const rv = new _.ColdPromise();
    options = _.options(options, {
      url: '',
      start: null,
      end: null,
    });

    if (_.isEmpty(options.url)) {
      app.doctorController.report('videoTrimming.post empty url');
      return rv;
    }

    $.ajax({
      url: app.apiUrl('/api/v1/assets/preview'),
      method: 'POST',
      timeout: app.TIME.MINUTE,

      data: {
        url: this._omitUrlProtocol(options.url),
        start: options.start,
        end: options.end,
      },

      error: (jqXHR, textStatus) => {
        if (textStatus !== 'abort') {
          rv.reject(this.createError(jqXHR));
        }
      },

      success: (res) => {
        if (_.isObject(res) && 'OK' === res.response) {
          rv.resolve(res);
        } else {
          rv.reject({ error: 'BAD_RESPONSE' });
        }
      },
    });

    return rv;
  },

  get(options) {
    const rv = new _.ColdPromise();
    options = _.options(options, {
      url: '',
      start: null,
      end: null,
    });

    if (_.isEmpty(options.url)) {
      app.doctorController.report('videoTrimming.get empty url');
      return rv;
    }

    $.ajax({
      url: app.apiUrl('/api/v1/assets/preview', {
        url: this._omitUrlProtocol(options.url),
        start: app.sfp(options.start),
        end: app.sfp(options.end),
      }),
      method: 'GET',
      timeout: app.TIME.MINUTE,

      error: (jqXHR, textStatus) => {
        if (textStatus !== 'abort') {
          rv.reject(this.createError(jqXHR));
        }
      },

      dataType: 'json',
      success: (res) => {
        if ('OK' === res.response) {
          app.prependHttpAcrossObject(res);
          rv.resolve(res);
        } else {
          rv.reject();
        }
      },
    });

    return rv;
  },
});
